// @flow
import React, {useEffect, useState} from 'react';
import {Redirect, useParams} from "react-router-dom";
import Header from "../Header";
import BackButton from "../../GUI_COMMON/COMPONENTS/BackButton";
import LIButton from "../../GUI_COMMON/COMPONENTS/LIButton";
import Popup from "../../GUI_COMMON/COMPONENTS/Popup";
import ArchiverClientApi from "../../API/archiverClientApi";
import ArchiverGuiUtils from "../../SUPPORT/ArchiverGuiUtils";
import LoadingSpinner from "../../GUI_COMMON/COMPONENTS/LoadingSpinner";
import {useHistory} from "react-router";

const SetDeviceProfileSetsAdminPage = () => {
    
    const [fullProfileSetList, setFullProfileSetList] = useState([]);
    const [deviceProfileSetIdList, setDeviceProfileSetIdList] = useState([]);
    const [someDeviceDetails, setSomeDeviceDetails] = useState({id:null,fullName:""});
    
    const [isDirty, setIsDirty] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const [redirectTo, setRedirectTo] = useState();

    const {deviceId,deviceName} = useParams();
    const history = useHistory();
    
    useEffect(() => {
        console.debug("refreshing device's profileSets list");
        setSomeDeviceDetails({id:deviceId, fullName:decodeURIComponent(deviceName)});
        getAllProfileSets();
        getDeviceProfileSetsList();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    
    function getAllProfileSets() {
        setIsLoading(true);
        ArchiverClientApi.getProfileSets()
        .then( (profileSets) => {
            setFullProfileSetList(profileSets??[]);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
            setIsLoading(false);
        });
    }
    
    function getDeviceProfileSetsList() {
        setIsLoading(true);
        ArchiverClientApi.getProfileSetsForDevice(deviceId) 
        .then( (profileSets) => {
            setupDeviceProfileSetIds(profileSets);  // we keep track of ids only really
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
            setIsLoading(false);
        });
    }

    function setupDeviceProfileSetIds(profileSets) {
        const ids = profileSets.map(p => p.id);
        setDeviceProfileSetIdList(ids);
    }
    
    function handleCancelClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        
        handleBackButtonClicked();
    }
    
    function handleSaveClicked(e,action) {
        e.preventDefault();
        e.stopPropagation();
        
        setIsSaving(true);
        ArchiverClientApi.updateProfileSetsForDevice(deviceId,deviceProfileSetIdList)
        .then( (result) => {
            Popup.showInfo(`Profile Sets Saved for ${someDeviceDetails.fullName}`);
            setIsDirty(false);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
           setIsSaving(false); 
        });
    }
    
    function handleCBChanged(e,profileId) {
        e.stopPropagation();
        
        const deviceIdList = [...deviceProfileSetIdList];
        if(deviceIdList.includes(profileId) && !e.target.checked) { // remove
            const index = deviceIdList.indexOf(profileId);
            deviceIdList.splice(index, 1);
        }
        else if(!deviceIdList.includes(profileId) && e.target.checked) { // add
            deviceIdList.push(profileId);
        }
        setDeviceProfileSetIdList(deviceIdList);
        setIsDirty(true);
    }

    function handleCBClicked(e) {
        e.stopPropagation(e);
    }
    
    function handleBackButtonClicked() {
        if(isDirty) {
            Popup.showConfirm("Cancel?","You have changed some information.","Forget changes",null,
                () => {
                    setRedirectTo(`/admin/devices/${deviceId}`);
                });
        }
        else {
            setRedirectTo(`/admin/devices/${deviceId}`);
        }
    }
    
    function isProfileSetInDeviceList(profileSetId) {
        return deviceProfileSetIdList.includes(profileSetId);
    }

    function handleGotoProfileSet(profileSetId:number) {
        const target = `/admin/profile_sets/${profileSetId}`;
        if (isDirty) {
            Popup.showConfirm("Cancel?", "You have changed some information.", "Forget changes", null, () => {
                history.push(target);
            });
        } else {
            history.push(target);
        }
    }
    
    function showProfileSetsList() {
        if (isLoading) {
            return <div className="mt-4 pr-4 w-30 li-border-right-light"><LoadingSpinner medium center/></div>;
        }

        let resultList = fullProfileSetList?.map((item, index) => {
            const extraClass = (item.enabled ? "" : "li-strike-through");
            return <li key={index} className={"list-group-item li-pointer "+extraClass}>
                        <div className="row m-0 p-0 justify-content-between">
                            <div>
                                <input name={"profileSet"+index} type="checkbox" className="mr-3" checked={isProfileSetInDeviceList(item.id)}
                                       onChange={(e)=>handleCBChanged(e,item.id)}
                                       onClick={handleCBClicked} value={index}/>
                                {item.name}<br/>
                                <div className="ml-5">
                                    Description:
                                    <span className="ml-2 li-fg-slightly-muted">
                                        {item.description}
                                    </span>
                                </div>
                            </div>
                            <LIButton faIcon="fa fa-external-link" primary onClick={() => handleGotoProfileSet(item.id)}/>
                        </div>    
                    </li>
        });
        if (!resultList || resultList.length === 0) {
            resultList = "no profile sets found";
        }

        return (<div className="mt-4">
                    <h4>Profile Sets</h4>
                    <div className="li-scrollable-at-750 li-border-light-top p-0 m-0">
                        <ul className="list-group-flush li-list-group-w-hover pl-0">
                            {resultList}
                        </ul>
                        <div className="li-border-line-light"/>
                    </div>
                </div>);
    }
    
    if (redirectTo) {
        return <Redirect to={redirectTo}/>;
    }
    
    return (
        <div className="container">
            <Header hideAdmin/>
            <div className="row m-0 p-0 li-header-row justify-content-between">
                <div>
                    <BackButton onClick={handleBackButtonClicked}/>
                    <h1 className="ml-4 d-inline-block align-middle">Assign Profile Sets</h1>
                </div>
            </div>

            <div className="li-font-large mt-3">
                Device:
                <span className="li-fg-slightly-muted ml-3">{someDeviceDetails.fullName}</span>
            </div>
            
            {showProfileSetsList()}

            {/* BUTTON ROW */}
                <div className="text-center my-5">
                    <span className={isDirty?"":"d-none"}>
                    <LIButton name="cancel" label="Cancel" bgClass="mr-4" primary onClick={handleCancelClicked}/>
                    </span>
                    <LIButton name="save" label="SAVE" secondary disabled={!isDirty || isSaving} 
                              onClick={(e)=>handleSaveClicked(e)} showBusy={isSaving}/>
                </div>
        </div>
    );
}

SetDeviceProfileSetsAdminPage.propTypes = {
   
};

export default SetDeviceProfileSetsAdminPage;